import { useSyncExternalStore } from 'react';

/**
 * A phone's reading page (reader.css, max-width 600px): its foot margin is one
 * line of small type, so nothing floats in its corners; the bar carries past
 * conversations, and the page's number is also the way to ask about the page.
 */
export const TIGHT = '(max-width: 600px)';

/** Whether a media query matches now, re-rendering when that changes. */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const m = window.matchMedia(query);
      m.addEventListener('change', cb);
      return () => m.removeEventListener('change', cb);
    },
    () => window.matchMedia(query).matches,
  );
}
